import React from 'react'
import PageTitle from './PageTitle';
import ExpCard from './ExpCard';

const Experience = (props) => {

    return (
        <section>
            <div className='education-wrapper common-padding'>
                <PageTitle title="Experience" />
                <div className="mt-4 w-100 educard-wrapper">
                    <ExpCard course="Techved Consulting" details="Frontend Developer" date="December 2020 - Present" />
                </div>
            </div>

            <div className="navi-wrapper">
                <button className="navi-btn" onClick={() => props.setActive("education")} >
                    <i className='fa fa-arrow-up'></i>
                </button>
                <button className="navi-btn" onClick={() => props.setActive("skills")} >
                    <i className='fa fa-arrow-down'></i>
                </button>
            </div>
        </section>
    )
}

export default Experience